// extracted by mini-css-extract-plugin
export default {"AssessmentGet":"AssessmentGet_AssessmentGet__M87te","title":"AssessmentGet_title__RLz85","content":"AssessmentGet_content__tSgUB"};